import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { get, forEach, filter, isEmpty } from "lodash";
import Grid from "@material-ui/core/Grid";

import { fetchPost, fetchPut } from "../../../api/fetch";
import CustomButton from "../../Common/CustomButton";
import DataPrivacyConsent from "./DataPrivacyConsent";
import {
  getAcceptances,
  processPoliciesStatus,
} from "../../../actions/policies";
import { API_DATASTORE } from "../../../constants/api";
import { dbFormat } from "../../../utils/date";
import { isAllowed } from "../../../utils/users";
import colors from "../../../assets/style/colors";

const styles = {
  document: {
    height: "calc(100vh - 410px)",
    overflow: "auto",
  },
  actionBar: {
    height: "80px",
  },
  redButton: {
    backgroundColor: colors.threatRed,
    color: colors.white,
    "&:hover": {
      backgroundColor: colors.threatRed,
    },
  },
  greenButton: {
    backgroundColor: colors.cardGreen,
    color: colors.white,
    "&:hover": {
      backgroundColor: colors.cardGreen,
    },
  },
};

const DataPrivacyDocument = (props) => {
  const {
    classes,
    dispatch,
    user,
    selectedPolicy,
    policyContent,
    policies,
    isMe,
    permissions,
  } = props;

  const acceptance = get(
    filter(
      get(policies, ["acceptances"]),
      (a) => get(a, ["policy", "id"]) === get(selectedPolicy, ["id"])
    ),
    [0]
  );

  const setAcceptance = async (accepted) => {
    try {
      let body = {
        value: {
          date: dbFormat(new Date()),
          accepted,
          "user-agent": navigator.userAgent,
          user: {
            id: get(user, ["id"]),
            name: `${get(user, ["firstName"])} ${get(user, ["lastName"])}`,
          },
          policy: {
            id: get(selectedPolicy, ["id"]),
            name: get(selectedPolicy, ["name", "en"]),
            published: get(selectedPolicy, ["published"]),
            revision: get(selectedPolicy, ["revision"]),
          },
        },
        versioning: false,
      };
      if (acceptance) {
        let index;
        forEach(get(policies, ["acceptances"]), (a, i) => {
          if (get(a, ["policy", "id"]) === get(selectedPolicy, ["id"])) {
            index = i;
          }
        });
        await fetchPut(
          `ds/usr/acceptances/${index}`,
          body.value,
          API_DATASTORE
        );
      } else {
        await fetchPost("ds/usr/acceptances", body, API_DATASTORE);
      }
      await dispatch(getAcceptances());
      await dispatch(processPoliciesStatus());
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Grid container direction="column">
      <Grid item className={classes.document}>
        {policyContent ? (
          <object
            style={{ maxHeight: "calc(100vh - 416px)" }}
            data={policyContent}
            type="application/pdf"
            width="100%"
            height="100%"
          >
            alt: <span>{I18n.get("profiles_policyNotFound")}</span>
          </object>
        ) : (
          <div
            className="text-54 text-italic text-center"
            style={{ marginTop: "140px" }}
          >
            {I18n.get("profiles_selectDocumentInTheTable")}
          </div>
        )}
      </Grid>
      <Grid item className={classes.actionBar}>
        {!isEmpty(selectedPolicy) && (
          <Grid container alignItems="center" style={{ height: "100%" }}>
            {get(selectedPolicy, ["compliance", "compliance"]) ===
              "optional" ? (
              <>
                {get(acceptance, ["accepted"]) === true ? (
                  <Grid item xs className="text-54 text-center">
                    {I18n.get("profiles_iHaveRead")}
                  </Grid>
                ) : (
                  <>
                    <Grid
                      item
                      className="text-54"
                      style={{ marginRight: "20px", paddingLeft: "12px" }}
                    >
                      {I18n.get("profiles_pleaseConfirmRead")}
                    </Grid>
                    <Grid item>
                      <CustomButton
                        variant="contained"
                        color="primary"
                        onClick={() => setAcceptance(true)}
                        disabled={
                          isMe &&
                          !isAllowed(permissions, "me.dataprivacy.update")
                        }
                      >
                        {I18n.get("profiles_iConfirm")}
                      </CustomButton>
                    </Grid>
                  </>
                )}
              </>
            ) : (
              <>
                <Grid item xs={3} />
                {!get(acceptance, ["accepted"]) && (
                  <Grid item xs={3} className="text-center">
                    {get(acceptance, ["accepted"]) === false ? (
                      <DataPrivacyConsent
                        policy={selectedPolicy}
                        acceptances={get(policies, ["acceptances"])}
                        center
                      />
                    ) : get(selectedPolicy, ["state"]) === "published" ? (
                      <CustomButton
                        variant="contained"
                        classes={{ root: classes.redButton }}
                        onClick={() => setAcceptance(false)}
                        disabled={
                          isMe &&
                          !isAllowed(permissions, "me.dataprivacy.update")
                        }
                      >
                        {I18n.get("profiles_iRefuse")}
                      </CustomButton>
                    ) : null}
                  </Grid>
                )}
                <Grid item xs>
                  {get(acceptance, ["accepted"]) === true ? (
                    <DataPrivacyConsent
                      policy={selectedPolicy}
                      acceptances={get(policies, ["acceptances"])}
                      center
                    />
                  ) : get(selectedPolicy, ["state"]) === "published" ? (
                    <CustomButton
                      variant="contained"
                      classes={{ root: classes.greenButton }}
                      onClick={() => setAcceptance(true)}
                      disabled={
                        isMe && !isAllowed(permissions, "me.dataprivacy.update")
                      }
                    >
                      {I18n.get("profiles_iAccept")}
                    </CustomButton>
                  ) : null}
                </Grid>
                <Grid item xs={3} />
              </>
            )}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(DataPrivacyDocument)
);
